export const experience = [
  {
    id: 1,
    period: "03/2022 – Present",
    position: "Senior Full Stack Developer",
    company: "NADRA, Islamabad, Pakistan",
    responsibilities: [
      "Designed and developed scalable backend services using Java and Spring Boot.",

      "Led frontend architecture and development using React.js, Next.js, and Angular.",

      "Played a key role in full-stack development, often working simultaneously on backend and frontend modules.",

      "Built and maintained microservice-based architectures for large-scale government applications.",

      "Integrated biometric authentication, payment systems, and third-party APIs into secure digital platforms.",

      "Collaborated with cross-functional teams to gather requirements, design solutions, and deploy applications.",

      "Contributed to UI/UX improvements and responsive design for citizen-facing applications.",
    ],
    technologies: [
      "Java",
      "SpringBoot",
      "Javascript",
      "TypeScript",
      "Node JS",
      "Angular",
      "React",
      "Next JS",
      "Oracle",
      "PostgreSQL",
      "MongoDB",
      "JWT",
      "Rest Api",
      "ANTD/MUI/Prime NG/React",
    ],
  },
  {
    id: 2,
    period: "11/2021 – 04/2022",
    position: "Software Engineer-III",
    company: "10PEARLS, Islamabad, Pakistan",
    responsibilities: [
      "Worked across both backend (Java Spring Boot, Node.js/Express) and frontend (Angular, React)  to deliver scalable web applications.",

      "Built RESTful APIs, dynamic UI components, and implemented secure authentication using JWT.",

      "Collaborated closely with clients and internal teams to translate requirements into functional features.",

      "Ensured application performance, code quality, and smooth deployment across PostgreSQL and AWS environments.",
    ],
    technologies: [
      "Java",
      "SpringBoot",
      "TypeScript",
      "Javascript",
      "Angular",
      "Node JS",
      "Postgress SQL",
    ],
  },
  {
    id: 3,
    period: "11/2020 – 11/2021",
    position: "Software Developer",
    company: "Auxiliotech Inc. , Islamabad, Pakistan",
    responsibilities: [
      "Developed both frontend (Angular) and backend (Node.js) for a workflow automation platform using PostgreSQL and AWS.",

      "Created and optimized 20+ REST APIs, improved query performance, and resolved backend memory issues.",

      "Implemented lazy loading and modular architecture to enhance frontend performance and reduce build size.",

      "Deployed and managed scalable application infrastructure on AWS using best practices for cloud development.",
    ],
    technologies: [
      "TypeScript",
      "Javascript",
      "Angular",
      "Node JS",
      "Postgress SQL",
      "AWS",
    ],
  },
  {
    id: 4,
    period: "01/2020 – 11/202",
    position: "Software Engineer",
    company: "VEROKE, Islamabad, Pakistan",
    responsibilities: [
      "Delivered full stack solutions across multiple projects using Java Spring Boot, Node.js (backend) and Angular/React (frontend).",

      "Built and optimized REST APIs, integrated third-party services, and implemented secure data workflows.",

      "Developed responsive and interactive UI components with Angular and React, ensuring smooth user experiences.",

      "Contributed to backend dashboards, payment integration, and real-time features using PostgreSQL, MongoDB, and WebSockets.",
    ],
    technologies: [
      "Java",
      "SpringBoot",
      "TypeScript",
      "Javascript",
      "Angular",
      "React",
      "Node JS",
      "JWT",
      "Rest Api",
    ],
  },
  {
    id: 5,
    period: "01/2017 – 12/2019",
    position: "Jnr. Software Engineer",
    company: "SIGNUP Solution, Rawalpind, Pakistan",
    responsibilities: [
      " Developed full stack web applications using Angular (frontend) and Node.js (backend) with PostgreSQL and MongoDB.",

      "Built secure REST APIs, integrated WebSockets for real-time updates, and implemented OAuth/Auth0 for user authentication.",

      "Collaborated with cross-functional teams to design dashboards, automate workflows, and enhance user experience across multiple domains.",

      "Contributed to Agile-based sprints using JIRA, ensuring timely delivery of features and resolving performance bottlenecks.",
    ],
    technologies: [
      "Javascript",
      "TypeScript",
      "Mongo DB",
      "Angular",
      "React",
      "JWT",
      "Rest Api",
    ],
  },
  // Add all other experiences in the same format
];
